import Vue from 'vue'
import VueIframe from 'vue-iframes'

Vue.use(VueIframe)